import React from "react";
import NoDataFound from "./NoData";
import VoucherCard from "./VoucherCard";
import { expiredVouchers } from "./UserData";
import { ReactComponent as EditIcon } from "../../images/edit.svg";
import { ReactComponent as DeleteIcon } from "../../images/delete.svg";
import CustomSlider from "../../components/Slider/CustomSlider";
import { FormatFlooringVouchers } from "../../common/Constants";

function ExpiredRedeemedContent(props) {
  const { expired_vouchers, handleCreateNewClick, HandleEdit, HandleDelete, pagePermission } =
    props;

  const handleNoDataClick = () => {
    console.log("Click Create");
    handleCreateNewClick();
  };

  const HandleExpiredEdit = (id, label) => {
    HandleEdit(id, label, "in-active")
  }

  const updatedExpiredVoucher = FormatFlooringVouchers(expired_vouchers?.map((it) => {
    return {
      ...it,
      active: it?.active == 1 ? false : true,
      temp_date: it?.created_date.slice(0, 10)
    };
  }));
  return (
    <div className="pending-vouchers-section">
      {expired_vouchers.length === 0 ? (
        <NoDataFound
          onNewClick={handleNoDataClick}
          btnName=""
          heading="Oh oh! No Voucher Found"
          noDataInfo=""
        />
      ) : (
        updatedExpiredVoucher && updatedExpiredVoucher?.length > 0 && updatedExpiredVoucher?.map((it) => (
          <div>
            <div className="hr-line-menu">
              <div className="hr-line-block">
                <h2>
                  <span>Created on:</span>
                  {it.date}
                </h2>
              </div>
            </div>
            <div className="voucher-preview-section activeVouchers">
              <CustomSlider>
                {it?.vouchers &&
                  it?.vouchers.map((voucher, index) => (
                    <VoucherCard
                      key={index}
                      voucher={voucher}
                      showBentoMenu={true}
                      type="inactive"
                      HandleEdit={HandleExpiredEdit}
                      HandleDelete={HandleDelete}
                      pagePermission={pagePermission}
                    />
                  ))}
              </CustomSlider>
            </div>
          </div>
        ))
      )}
    </div>
  );
}

export default ExpiredRedeemedContent;
